import { formatDaysToTime } from "utils/timesheet";

export const DisplayDays = ({ value = 0, precision = 2, format = true }) => {
  if (value === null) {
    return;
  }
  if (format) {
    return formatDaysToTime(value);
  }
  return value;
};
